// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuickReplies_wrapper__2u1Cy","popup":"QuickReplies_popup__2aFy9","button":"QuickReplies_button__2lWCf","icon":"QuickReplies_icon__B7FLc"};